<template>
  <generic-container :show_plus="false" icon="users" :title="$t('users')">
    <table class="ui compact celled striped definition table">
      <thead class="full-width">
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("branch") }}</th>
          <th>{{ $t("limit to students in same branch") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(user, index) in setup.std_users" v-bind:key="index">
          <td>{{ user.name }}</td>
          <td>
            <div class="ui selection dropdown" ref="branch_dropdown">
              <input
                type="hidden"
                name="ddwn"
                :value="user.std_user ? user.std_user.branch_id : ''"
              />
              <i class="dropdown icon"></i>
              <div class="default text">{{ $t("select one") }}</div>
              <div class="menu">
                <div class="item" data-value="" :data-student="user.user_id">
                  {{ $t("no one") }}
                </div>
                <div
                  class="item"
                  :data-value="branch.branch_id"
                  v-for="(branch, idx) in setup.std_branches"
                  :key="idx"
                  :data-student="user.user_id"
                >
                  {{ branch.name }}
                </div>
              </div>
            </div>
          </td>
          <td>
            <div
              class="ui toggle checkbox"
              v-bind:class="{ disabled: !user.std_user }"
              ref="limit_branch_checkbox"
              :data-u="user.user_id"
            >
              <input
                type="checkbox"
                :checked="
                  user.std_user ? user.std_user.limit_to_branch_students : false
                "
              />
              <label></label>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, stringify } from "@/utils";

export default {
  name: "StudentConfigurationModalUsers",
  components: {
    GenericContainer,
  },
  props: {
    // setup: Object,
  },
  data() {
    return {
      selected_user: {},
      setup: {},
    };
  },
  methods: {
    update_limit_policy(user_id, is_limited) {
      let vm = this;
      local_api(vm, "post", "/student_configuration/do-save-user", {
        l: is_limited,
        u: user_id,
      })
        .then(() => {})
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    },
    set_setup(setup) {
      console.log("setting setup");
      let vm = this;
      vm.setup = setup;

      setTimeout(() => {
        window.jQuery(vm.$refs.branch_dropdown).dropdown({
          onChange(value, text, element) {
            let branch_id = value;
            let user_id = window.jQuery(element).data("student");
            local_api(vm, "post", "/student_configuration/do-save-user", {
              b: branch_id,
              u: user_id,
            })
              .then(() => {})
              .catch((err) => {
                vm.$alertify.error(stringify(err));
              });
          },
        });

        window.jQuery(vm.$refs.limit_branch_checkbox).checkbox({
          onChecked() {
            let elmnt = window.jQuery(this).closest(".checkbox");
            let user_id = elmnt.data("u");
            vm.update_limit_policy(user_id, true);
          },
          onUnchecked() {
            let elmnt = window.jQuery(this).closest(".checkbox");
            let user_id = elmnt.data("u");
            vm.update_limit_policy(user_id, false);
          },
        });
      }, 1000);
    },
  },
  mounted() {
    // let vm = this;
    // setTimeout(() => {
    //   window.jQuery(vm.$refs.branch_dropdown).dropdown({
    //     onChange(value, text, element) {
    //       let branch_id = value;
    //       let user_id = window.jQuery(element).data("student");
    //       local_api(vm, "post", "/student_configuration/do-save-user", {
    //         b: branch_id,
    //         u: user_id,
    //       })
    //         .then(() => {})
    //         .catch((err) => {
    //           vm.$alertify.error(stringify(err));
    //         });
    //     },
    //   });
    //   window.jQuery(vm.$refs.limit_branch_checkbox).checkbox({
    //     onChecked() {
    //       let elmnt = window.jQuery(this).closest(".checkbox");
    //       let user_id = elmnt.data("u");
    //       vm.update_limit_policy(user_id, true);
    //     },
    //     onUnchecked() {
    //       let elmnt = window.jQuery(this).closest(".checkbox");
    //       let user_id = elmnt.data("u");
    //       vm.update_limit_policy(user_id, false);
    //     },
    //   });
    // }, 4000);
  },
};
</script>
